const mobileAppsContract = {
  "apps": {
    "loanonline": {
      "source": "mobile-app",
      "platforms": [
        "ios",
        "android"
      ],
      "alpha": {
        "stores": {
          "android": "https://play.google.com/apps/testing/ph.loanonline.alpha"
        }
      },
      "testerSignup": {
        "note": "Ask for access"
      },
      "brands": {
        "loanonline-ph": {
          "status": {
            "android": "live",
            "ios": "live",
            "alpha": "testing"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=ph.loanonline",
            "ios": "https://apps.apple.com/ph/app/id6751632738"
          }
        }
      }
    },
    "paisa247": {
      "source": "mobile-app",
      "platforms": [
        "ios",
        "android"
      ],
      "alpha": {
        "stores": {
          "android": "https://play.google.com/apps/testing/in.paisa247.alpha"
        }
      },
      "testerSignup": {
        "url": "https://www-dev.paisa247.in/utils/mobile-app"
      },
      "brands": {
        "paisa247-in": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "testing"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=in.paisa247"
          },
          "loginHandoff": true
        }
      }
    },
    "jeff": {
      "source": "mobile-app",
      "platforms": [
        "ios",
        "android"
      ],
      "alpha": {
        "stores": {
          "android": "https://play.google.com/apps/testing/com.jeff.app"
        }
      },
      "testerSignup": {
        "note": "Paused"
      },
      "brands": {
        "jeff-vn": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "paused"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=com.jeff.app"
          }
        }
      }
    },
    "finmart": {
      "source": "mobile-app",
      "platforms": [
        "ios",
        "android"
      ],
      "alpha": {
        "stores": {
          "android": "https://play.google.com/apps/testing/app.j3ff.finmart.alpha"
        }
      },
      "testerSignup": {
        "url": "https://www-dev.finmercado.mx/utils/mobile-app"
      },
      "brands": {
        "finmart-vn": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "testing"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=app.j3ff.finmart"
          }
        },
        "finmart-id": {
          "status": {
            "android": "none",
            "ios": "none",
            "alpha": "none"
          }
        },
        "finmart-my": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "testing"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=app.j3ff.finmart"
          }
        },
        "finmart-pk": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "none"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=app.j3ff.finmart"
          }
        },
        "finmart-bd": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "none"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=app.j3ff.finmart"
          }
        },
        "finmart-th": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "none"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=app.j3ff.finmart"
          }
        },
        "finmart-za": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "none"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=app.j3ff.finmart"
          }
        },
        "finmart-mx": {
          "status": {
            "android": "live",
            "ios": "none",
            "alpha": "none"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=app.j3ff.finmart"
          }
        }
      },
      "retired": [
        {
          "name": "Finmart.id – Choose Your Loan",
          "package": "com.jeff.app.id",
          "country": "id",
          "store": "android",
          "status": "suspended",
          "since": "2024-03-29",
          "playConsole": "https://play.google.com/console/u/0/developers/8812868799701484282/app/4975639399357416835/app-dashboard"
        },
        {
          "name": "Finmart.id – Pilih Pinjaman Anda",
          "package": "com.jeff.app.ida",
          "country": "id",
          "store": "android",
          "status": "unpublished",
          "since": "2024-05-10",
          "playConsole": "https://play.google.com/console/u/0/developers/8812868799701484282/app/4973498108160798760/app-dashboard"
        }
      ]
    },
    "finmercado": {
      "source": "external",
      "platforms": [
        "ios",
        "android"
      ],
      "alpha": {
        "stores": {
          "android": "https://play.google.com/apps/testing/mx.finmercado.alpha"
        }
      },
      "testerSignup": {
        "url": "https://www-dev.finmercado.mx/utils/mobile-app"
      },
      "brands": {
        "finmercado-mx": {
          "status": {
            "android": "live",
            "ios": "live",
            "alpha": "testing"
          },
          "stores": {
            "android": "https://play.google.com/store/apps/details?id=mx.finmercado",
            "ios": "https://apps.apple.com/mx/app/apple-store/id6756575860?pt=125081013&ct=sitio-web-boton&mt=8"
          }
        },
        "finmercado-co": {
          "status": {
            "android": "testing",
            "ios": "live",
            "alpha": "none"
          },
          "testing": {
            "android": "https://play.google.com/apps/testing/co.finmercado"
          },
          "stores": {
            "ios": "https://apps.apple.com/co/app/finmercado-colombia/id6751941717"
          },
          "websiteDownload": false
        }
      }
    }
  }
} as const;

export default mobileAppsContract;
